import {FilterWithCameraScanCommandHandler} from './filter-with-camera-scan.command-handler';
import {FormControl} from '@angular/forms';
import {DomainCommand} from '../../modules/command-bus/command';

export class FilterWithCameraScanCommand extends DomainCommand {
  constructor(control: FormControl) {
    super(FilterWithCameraScanCommandHandler, {control});
  }
}
